module.exports = __webpack_public_path__ + "static/img/patho-inflammation-high-DZojNc3U.07f3200f.png";